import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'

import DashboardIndex from './views/dashboard/DashboardIndex.vue'

import /* webpackChunkName: "LmRouterView" */ LmRouterView from '@/components/LmRouterView.vue'
import /* webpackChunkName: "LmList" */ LmList from '@/components/LmList.vue'
import /* webpackChunkName: "NewOrEdit" */ NewOrEdit from '@/views/coupons/NewOrEdit.vue'
import /* webpackChunkName: "calendar" */ DashboardHome from '@/views/dashboard/DashboardHome.vue'
import /* webpackChunkName: "LmNewOrEdit" */ LmNewOrEdit from '@/components/LmNewOrEdit.vue'

const vueComponents = {
  LmRouterView,
  LmList,
  NewOrEdit,
  DashboardHome,
  LmNewOrEdit
}

Vue.use(Router)

class MetaBreadcrumb {
  constructor (name, to) {
    this.name = name
    this.to = to
  }
}

export async function createRouter () {
  let routerConfig = {
    mode: 'history',
    routes: [
      {
        path: '/',
        name: 'dashboard_index',
        component: DashboardIndex,
        meta: {
          breadcrumb: new MetaBreadcrumb('Dashboard', '/')
        },
        children: [
          {
            path: '',
            name: 'dashboard_home',
            meta: {
              title: 'Dashboard'
            },
            component: () => import(/* webpackChunkName: "calendar" */ '@/views/dashboard/DashboardHome.vue')
          },
          {
            path: '/user-profile',
            name: 'user-profile',
            component: () => import(/* webpackChunkName: "user-profile" */ '@/views/LmUserProfile.vue')
          }
        ]
      },
      {
        path: '/login',
        name: 'login',
        meta: {
          title: 'Login'
        },
        component: () => import(/* webpackChunkName: "login" */ './views/Login.vue')
      },
      {
        path: '/callback',
        name: 'callback',
        component: () => import(/* webpackChunkName: "callback" */ './views/Callback.vue')
      },
      {
        path: '*',
        name: '404',
        component: () => import(/* webpackChunkName: "404" */ './views/404.vue')
      }
    ]
  }

  // Se cargan las rutas dinamicamente desde el endpoint de la API
  let apiResponse = await axios.get('settings/routesconfig/')
  // XXX: Falta manejo de errores
  // https://github.com/lumile/lumbre/issues/169
  apiResponse.data.routesConfigs.forEach(newRoute => {
    if (newRoute.component in vueComponents) {
      newRoute.component = vueComponents[newRoute.component]
      newRoute.meta.breadcrumb = new MetaBreadcrumb(newRoute.meta.breadcrumb)
      newRoute.children = newRoute.children.map(child => {
        child.component = vueComponents[child.component]
        return child
      })
      routerConfig.routes[0].children.push(newRoute)
    }
  })
  return new Router(routerConfig)
}
